const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"supplier_content":({"supplier_information":"Supplier information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;